import { RootState } from '@store/index'

export const selectIsLoaderVisible = (state: RootState): boolean => state.loaderState.isVisible
